import {
  FormProvider,
  UseFormReturn,
  SubmitHandler,
  FieldValues
} from 'react-hook-form'

interface CustomFormProviderProps<T extends FieldValues = FieldValues> {
  formMethods: UseFormReturn<T>
  onSubmit: SubmitHandler<T>
  children: React.ReactNode
}

const CustomFormProvider = <T extends FieldValues = FieldValues>({
  children,
  formMethods,
  onSubmit
}: CustomFormProviderProps<T>) => {
  return (
    <FormProvider {...formMethods}>
      <form
        className='h-full w-full'
        onSubmit={formMethods.handleSubmit(onSubmit)}
      >
        {children}
      </form>
    </FormProvider>
  )
}

export { CustomFormProvider }
